import { http } from "api/http";

const getCategories = () => {
  return http.get("/categories");
};

const getCategory = ({ queryKey }: any) => {
  return http.get(`/categories/category/${queryKey[1]}`);
};

const getDefaultCategories = () => {
  return http.get("/categories/default");
};

const createCategory = (data: any) => {
  return http.post("/categories", data);
};

const createSubCategory = (data: any) => {
  return http.post("/categories/add-sub-category", data);
};

const importCategories = (data: any) => {
  return http.post("/categories/import", data);
};

const deleteCategory = (id: any) => {
  return http.delete(`/categories/${id?.id}`);
};

const deleteSubCategory = (id: any) => {
  return http.delete(`/categories/sub-category/${id?.id}`);
};

const updateCategory = ({ id, data }: { id: number; data: any }) => {
  return http.put(`/categories/${id}`, data);
};

const updateSubCategory = ({ id, data }: { id: number; data: any }) => {
  return http.put(`/categories/sub-category/${id}`, data);
};

const updateAdminCategories = () => {
  return http.post(`/categories/update-admin-categories`);
};

export {
  getCategories,
  createCategory,
  updateCategory,
  deleteCategory,
  getDefaultCategories,
  importCategories,
  updateAdminCategories,
  getCategory,
  createSubCategory,
  deleteSubCategory,
  updateSubCategory,
};
